module.exports = __webpack_public_path__ + "img/logo.b36022c2.png";